var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterIcon42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "url(#paint0_linear_402_1668)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.649 12.6172C27.9754 12.9939 26.5844 13.6677 21.752 16.486C17.8833 18.7392 16.6227 19.71 15.6518 21.1807C14.2608 23.2817 14 24.8104 14 30.9178C14 37.018 14.2608 38.6626 15.5577 40.6622C16.5285 42.1691 17.9122 43.2559 21.6579 45.4366C26.5771 48.2983 28.0334 49.0083 29.7214 49.3561C30.7937 49.5807 32.4745 49.5372 33.496 49.2619C34.9378 48.8707 36.3722 48.1607 40.27 45.9075C42.7333 44.4803 43.849 43.792 44.7908 43.0965C46.8411 41.5968 47.9641 39.8798 48.406 37.5904C48.6741 36.2211 48.7176 35.0257 48.6813 30.2658C48.6596 26.5202 48.6306 25.6508 48.5292 25.0132C48.08 22.2167 46.9063 20.362 44.5155 18.6667C42.6029 17.3119 36.5461 13.8706 34.8508 13.1751C33.5902 12.6534 33.0179 12.5375 31.5689 12.5085C30.4821 12.4868 30.1634 12.5013 29.649 12.6172ZM32.8367 18.1016C34.4596 18.4059 36.0752 19.3043 37.1909 20.5069C40.0744 23.6295 40.0454 28.3459 37.1185 31.4105C35.0537 33.5695 32.076 34.3954 29.2288 33.5912C28.3159 33.3376 27.1205 32.7146 26.3598 32.0915C23.8096 30.0339 22.7808 26.5347 23.8096 23.4411C24.1936 22.2892 24.7514 21.3763 25.6208 20.4634C26.8162 19.2173 28.1276 18.4711 29.7359 18.1378C30.5908 17.9567 32.0036 17.9422 32.8367 18.1016ZM37.4735 37.8657C39.3209 38.17 40.9728 39.2205 41.9798 40.7492C42.4145 41.3939 42.458 41.5244 42.2913 41.6548C41.7045 42.0822 36.7055 44.9584 35.1841 45.7409C33.2569 46.7262 32.1847 47.0015 30.7574 46.8783C29.5403 46.7769 28.1855 46.1683 24.7224 44.176C23.0779 43.2341 20.8102 41.8938 20.39 41.6185C20.2668 41.5316 20.4335 41.1838 20.9044 40.539C21.9404 39.1335 23.4691 38.1845 25.1789 37.8729C25.9613 37.728 36.6113 37.728 37.4735 37.8657Z",
    fill: "url(#paint1_linear_402_1668)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_1668",
    x1: 31.5,
    y1: 0,
    x2: 31.5,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4190F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_1668",
    x1: 31.3462,
    y1: 49.5,
    x2: 31.3462,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EEF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon42);
export default __webpack_public_path__ + "static/media/footer_icon_4_2.08c12de7b7f69106e4a11c93cca28133.svg";
export { ForwardRef as ReactComponent };